import "./Project.css";

import Edit from "../../assets/edit.svg";
import Delete from "../../assets/delete.svg";

import { projectStore, selectOptionsStore } from "../../store/Store";

import UpdateRequired from "../../components/UpdateRequired";

export default function CarrierCard({
  setEditCarrier,
  setDeleteCarrier,
  setCarrierId,
  setDeleteFields,
}) {
  // global
  const currentProject = projectStore((data) => data.currentProject);
  const projectCarriers = projectStore((data) => data.projectCarriers);
  const projectUnaddedCarriers = projectStore((data) => data.projectUnaddedCarriers);
  const setProjectCarriers = projectStore((data) => data.setProjectCarriers);
  const setProjectUnaddedCarriers = projectStore((data) => data.setProjectUnaddedCarriers);
  const setProjectLoads = projectStore((data) => data.setProjectLoads);
  const setProjectAssetLoads = projectStore(
    (data) => data.setProjectAssetLoads,
  );
  const setProjectTotals = projectStore((data) => data.setProjectTotals);
  const carrierOptions = selectOptionsStore((data) => data.carrierOptions); 

  const handleEdit = (id) => {
    setEditCarrier(true);
    setCarrierId(id);
  };

  const handleDelete = (carr) => {
    setDeleteCarrier(true);
    setCarrierId(carr.id);
    setDeleteFields({
      setTrigger: setDeleteCarrier,
      id: carr.id,
      table: "project_carriers_tbl",
      endpoint: "project/carrier",
      nameField: getCarrierName(carr),
      setStates: [
        setProjectCarriers,
        setProjectLoads,
        setProjectAssetLoads,
        setProjectTotals,
        setProjectUnaddedCarriers,
      ],
      setStateFields: [
        "project_carriers",
        "project_loads",
        "project_asset_loads",
        "project_totals",
        "project_unadded_carriers",
      ],
    });
  };

  const getCarrierName = (carr) => {
    const carrier = carrierOptions.filter(
      (c) => c.value === carr.pc_carrier_id,
    );
    if (carrier.length > 0) {
      return carrier[0].label;
    }
  };

  return (
    carrierOptions.length !== 0 && (
      <div className="col-3">
        <div className="p-2 border text-center project-card">
          <div className="d-flex justify-content-between project-header">
            <h5>Carriers</h5>
          </div>
          {projectCarriers && <div className="project-card-list">
            <table className="table table-sm table-hover">
              <thead>
                <tr>
                  <th>Carrier</th>
                  <th>Rate Sheet</th>
                  <th>FSC</th>
                  {!currentProject.project.archived && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {projectCarriers.map((carr, idx) => (
                  <tr key={idx}>
                    <td>{carr && getCarrierName(carr)}</td>
                    <td>{carr.rate_sheet_name}</td>
                    <td>{carr.fsc_name}</td>
                    {!currentProject.project.archived && (
                      <td className="action">
                        <div className="d-flex justify-content-between">
                          <img
                            src={Edit}
                            className="edit"
                            onClick={() => handleEdit(carr.id)}
                            alt="edit"
                          />
                          <img
                            src={Delete}
                            className="edit"
                            onClick={() => handleDelete(carr)}
                            alt="delete"
                          />
                          {(carr.company_id === 0 ||
                            carr.carrier_name === "") && (
                            <UpdateRequired
                              message={"Please update this company"}
                              displayType={"Update"}
                            />
                          )}
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>}
          {projectUnaddedCarriers && projectUnaddedCarriers.length > 0 && (
            <div className="project-card-list">
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th>Unadded Carriers</th>
                  </tr>
                </thead>
                <tbody>
                  {projectUnaddedCarriers.map((carr, idx) => (
                    <tr key={idx}>
                      <td>{carr}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    )
  );
}
